module.exports = __webpack_public_path__ + "img/202305-xl.2f844c8d.png";